// removed by extract-text-webpack-plugin
module.exports = {"testimonial_wrapper":"src-components-testimonials----Testimonials-module---testimonial_wrapper---V5tZD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/testimonials/Testimonials.module.scss
// module id = 284
// module chunks = 74537795826934 162898551421021